import { defineStore } from 'pinia';
import { getSystemConfig } from '../api/legacy.js'

export default defineStore('configStore', {
	state: () => {
		return {
			appInit: false,  // 应用是否完成初始化
			fullScreen: true, // 当前是否全屏
			webrtc: {}
		}
	},
	actions: {
		setConfig(config) {
			this.webrtc = config.webrtc;
		},
		setAppInit(appInit) {
			this.appInit = appInit;
		},
		setFullScreen(fullScreen) {
			this.fullScreen = fullScreen;
		},
		loadConfig() {
			return new Promise((resolve, reject) => {
				getSystemConfig().then(config => {
					this.setConfig(config);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}
});
